var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", { attrs: { src: require("@/assets/img/logo.png"), alt: "" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "survey-title" }, [
        _c("span", [_vm._v(_vm._s(_vm.survey.name))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.survey.problems, function(problem, index) {
        return _c("div", { key: problem.id, staticClass: "problem" }, [
          _c("div", { staticClass: "problem-name" }, [
            _c("span", [
              _vm._v(_vm._s(index + 1 + "/" + _vm.survey.problems.length + "."))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(problem.name))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "options" },
            _vm._l(problem.options, function(option) {
              return _c("div", { key: option.id, staticClass: "option" }, [
                _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(option.name) + "\n          "
                  )
                ]),
                _vm._v(" "),
                option.optionContent
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(option.optionContent) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            }),
            0
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer flex" }, [
      _c("div", { staticClass: "primary item1", on: { click: _vm.exit } }, [
        _vm._v("退出")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2662a5ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2662a5ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/viewSurvey.vue
// module id = null
// module chunks = 